import React, { useState, useEffect } from "react";
import { db } from "../config/firebase";
import { collection, getDocs } from "firebase/firestore";
import CourseCard2 from "./courseCard2";

export default function Courses() {
  const [coursesData, setCoursesData] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const courses = [];
        const querySnapshot = await getDocs(collection(db, "Course"));
  
        if (querySnapshot.empty) {
          console.log("No matching documents.");
          return;
        }
  
        querySnapshot.forEach((doc) => {
          courses.push({ id: doc.id, ...doc.data() });
        });
  
        setCoursesData(courses);
        localStorage.setItem("coursesData", JSON.stringify(courses)); // Cache new data
      } catch (error) {
        console.log("Error getting courses:", error);
      }
    };
  
    fetchCourses(); // Always fetch fresh data
  }, []);
  

  return (
    <div className="courses-wrapper">
      <div className="header">
        <h1>Courses</h1>
      </div>
      <div className="card-container">
        {coursesData.length === 0 ? (
          <h2 className="no-courses">
            There are no courses available right now, please check again soon.
          </h2>
        ) : (
          coursesData.map((course) => (
            <CourseCard2 key={course.id} course={course} />
          ))
        )}
      </div>
      <style jsx>{`
        .courses-wrapper {
          background: linear-gradient(135deg, #f9f9f9, #e8e8e8);
          animation: gradient-shift 10s infinite alternate;
          padding: 40px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        @keyframes gradient-shift {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 10% 50%;
          }
        }

        .header h1 {
          font-size: 3rem;
          color: #333;
          margin-bottom: 20px;
          animation: fade-in 1s ease-in-out;
        }

        .card-container {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          width: 100%;
          max-width: 1400px;
        }

        .no-courses {
          text-align: center;
          padding: 20px;0
          font-size: 2rem;
          color: #333;
          animation: fade-in 1.5s ease-in-out;
        }

        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
